import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { userProfileService } from '../services/userProfileService';

export const getAllUserProfiles = createAsyncThunk(
  'userProfile/getAllUserProfiles',
  async (_, { rejectWithValue }) => {
    try {
      const response = await userProfileService.getAllUserProfiles();
      return response?.data || response;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

export const getUserProfilesByRole = createAsyncThunk(
  'userProfile/getUserProfilesByRole',
  async (role, { rejectWithValue }) => {
    try {
      const response = await userProfileService.getUserProfilesByRole(role);
      return response?.data || response;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

const userProfileSlice = createSlice({
  name: 'userProfile',
  initialState: {
    profiles: [],
    loading: false,
    error: null,
  },
  reducers: {
    clearError: (state) => {
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getAllUserProfiles.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getAllUserProfiles.fulfilled, (state, action) => {
        state.loading = false;
        state.profiles = action.payload;
      })
      .addCase(getAllUserProfiles.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(getUserProfilesByRole.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getUserProfilesByRole.fulfilled, (state, action) => {
        state.loading = false;
        state.profiles = action.payload;
      })
      .addCase(getUserProfilesByRole.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export const { clearError } = userProfileSlice.actions;

export default userProfileSlice.reducer;
